import ColumnText from "../molecules/ColumnText";
import { Fragment } from "react";
import { Empty } from "./Empty";
import { t } from "i18next";
import { TableLoader } from "../molecules/TableLoader";
import { DateTime } from "luxon";
import { Button } from "../atoms/Button";
import { faTrashCan } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  faFileInvoice,
  faPencil,
  faTrash,
} from "@fortawesome/pro-regular-svg-icons";

export type BillsTableProps = {
  isLoading: boolean;
  bills: any[];
  onDelete: (bill: any) => void;
  onDownloadInvoice: (bill: any) => void;
  onEdit: (bill: any) => void;
  onCreate: () => void;
};

export const BillsTable: React.FC<BillsTableProps> = ({
  isLoading,
  bills,
  onDelete,
  onDownloadInvoice,
  onEdit,
  onCreate,
}) => {
  return (
    <div className="flex-1 overflow-scroll flex flex-col border">
      <div className="flex flex-1 flex-col">
        {isLoading ? (
          <TableLoader columns={9} />
        ) : (
          <Fragment>
            {bills.length === 0 ? (
              <Empty texto={t("pages.bills.no_tasks")} onClick={onCreate} />
            ) : (
              <Fragment>
                <table className="divide-y divide-gray-300">
                  <thead>
                    <tr>
                      <th
                        scope="col"
                        className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900"
                      >
                        Fecha
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        Categoría
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        Concepto
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        Descripción
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        Cantidad
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        Proveedor
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        Acciones
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 bg-white">
                    {bills.map((bill: any) => (
                      <tr key={bill.id}>
                        <td className="whitespace-nowrap px-3 py-5 text-sm text-gray-500">
                          {console.log(bill)}
                          <p>
                            {DateTime.fromFormat(
                              bill.date,
                              "yyyy-MM-dd"
                            ).toFormat("dd-MM-yyyy")}
                          </p>
                          <small>
                            {DateTime.fromFormat(
                              bill.time,
                              "HH:mm:ss"
                            ).toFormat("HH:mm")}
                          </small>
                        </td>
                        <ColumnText
                          wrap
                          title={
                            <div className="flex flex-col">
                              <p>
                                {t(
                                  `accounting.views.categories.${bill.category}`
                                )}
                              </p>
                              <small>
                                {t(
                                  `accounting.views.subcategories.${bill.subcategory}`
                                )}
                              </small>
                            </div>
                          }
                        />
                        <ColumnText wrap title={bill.subject} />
                        <ColumnText wrap title={bill.description} />
                        <ColumnText
                          wrap
                          title={`${bill.currency.toUpperCase()} ${parseFloat(bill.amount).toFixed(2)}`}
                        />
                        <ColumnText wrap title={bill.selledBy} />
                        <td className="relative whitespace-nowrap py-5 pr-4 flex items-center pl-5 text-left text-sm font-medium sm:pr-0">
                          {bill.invoiceUrl && (
                            <Button
                              icon={faFileInvoice}
                              onClick={() => onDownloadInvoice(bill)}
                            />
                          )}
                          <a
                            onClick={() => onEdit(bill.id)}
                            href="#"
                            className="text-primary-600 hover:text-primary-900 mr-4"
                          >
                            {t("general.edit")}
                          </a>
                          <a
                            onClick={() => {
                              onDelete(bill);
                            }}
                            href="#"
                            className="text-red-600 hover:text-red-900"
                          >
                            <FontAwesomeIcon icon={faTrashCan} />
                          </a>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Fragment>
            )}
          </Fragment>
        )}
      </div>
    </div>
  );
};

export default BillsTableProps;
